import { render } from "./ThanhTieuDe.vue?vue&type=template&id=008de560&scoped=true"
import script from "./ThanhTieuDe.vue?vue&type=script&lang=js"
export * from "./ThanhTieuDe.vue?vue&type=script&lang=js"

import "./ThanhTieuDe.vue?vue&type=style&index=0&id=008de560&lang=scss&scoped=true"
import "./ThanhTieuDe.vue?vue&type=style&index=1&id=008de560&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-008de560"]])

export default __exports__